export default {
  contexts: {
    push: {
      passwordReset: {
        buttonText: 'Send Password Reset Request To Mobile Device',
        subheaderText: 'Authenticate with JumpCloud Protect to reset password',
      },
      login: {
        buttonText: 'Send Login Request To Mobile Device',
        subheaderText: 'Authenticate with JumpCloud Protect to complete login',
      },
    },
    totp: {
      passwordReset: {
        buttonText: 'Reset Password',
        subheaderText: 'Enter 6 digit verification code to reset password',
      },
      login: {
        buttonText: 'Login',
        subheaderText: 'Enter 6 digit verification code to complete login',
      },
    },
    webauthn: {
      passwordReset: {
        buttonText: 'Reset Password With Security Key',
        subheaderText: 'Authenticate with a Security Key to reset password',
      },
      login: {
        buttonText: 'Login With Security Key',
        subheaderText: 'Authenticate with a Security Key to complete login',
      },
    },
  },
};
